<template>
       <nav v-if="$route.path=='/info'" class="navbar navbar-expand-lg navbar-light bg-light py-1 " style=" padding: 0 1.5rem;">
  <div class="container-fluid">
  <div class="mt-2 me-3">
     <span class="">WATER LEVEL <span class="breadcrumb"> <span class="breadcrumb-active" style="font-size: 14px;">ข้อมูลบัญชีผู้ใช้</span></span>
             </span>
  </div>
   
                       
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
      <router-link  style="width: 100%;"    to='/' >
                 <button type="button" class="btn btn-outline-dark px-2 py-1 rounded-5 border-0" style="font-family: 'Kanit-Regular';font-size: 14px;"> 
                        <i class="bi bi-arrow-left"></i> กลับไปยังหน้าหลัก
                        
                        </button>
                               </router-link>
      </ul>
     
    </div>
  </div>
</nav>
  <div class="profile-container">
    <!-- <div class="profile-header">
      <div class="d-flex align-items-center">
        <div class="profile-icon">
          <i class="bi bi-person-circle"></i>
        </div>
        <div>
          <h4 class="mb-1">ข้อมูลส่วนตัว</h4>
          <p class="text-muted mb-0">จัดการข้อมูลและการตั้งค่าบัญชีของคุณ</p>
        </div>
      </div>
    </div> -->
  

    <div class=" ">
      <div class="row ">
        <!-- Left Section - Personal Info -->
        <div class="col-lg-6">
          <div class="info-card">
            <div class="card-title">
              <i class="bi bi-person-badge"></i>
              <span>ข้อมูลบัญชี</span>
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="bi bi-person"></i> ชื่อผู้ใช้
              </label>
              <input 
                type="text" 
                class="form-control modern-input" 
                placeholder="กรอกชื่อผู้ใช้" 
                v-model="my_user.username"
              >
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="bi bi-envelope"></i> อีเมล
              </label>
              <input 
                type="email" 
                class="form-control modern-input" 
                placeholder="กรอกอีเมล" 
                v-model="my_user.email"
              >
            </div>

            <div class="row g-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">
                    <i class="bi bi-card-text"></i> ชื่อจริง
                  </label>
                  <input 
                    type="text" 
                    class="form-control modern-input" 
                    placeholder="กรอกชื่อจริง" 
                    v-model="my_user.firstName"
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">
                    <i class="bi bi-card-text"></i> นามสกุล
                  </label>
                  <input 
                    type="text" 
                    class="form-control modern-input" 
                    placeholder="กรอกนามสกุล" 
                    v-model="my_user.lastName"
                  >
                </div>
              </div>
            </div>

            <div class="password-section">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <label class="form-label mb-1">
                    <i class="bi bi-shield-lock"></i> รหัสผ่าน
                  </label>
                  <p class="text-muted small mb-0">เปลี่ยนรหัสผ่านเพื่อความปลอดภัย</p>
                </div>
                <button 
                  type="button" 
                  class="btn btn-outline-dark btn-change-password"
                  data-bs-toggle="modal" 
                  data-bs-target="#changePasswordModal"
                >
                  <i class="bi bi-key"></i> เปลี่ยนรหัสผ่าน
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Section - Notes -->
        <div class="col-lg-6">
          <div class="info-card h-100">
            <div class="card-title">
              <i class="bi bi-journal-text"></i>
              <span>บันทึกช่วยจำ</span>
            </div>

            <div class="form-group flex-grow-1">
              <label class="form-label">
                <i class="bi bi-pencil-square"></i> หมายเหตุ
              </label>
              <textarea 
                class="form-control modern-textarea" 
                rows="10" 
                placeholder="เขียนบันทึกหรือหมายเหตุของคุณที่นี่..." 
                v-model="my_user.note"
              ></textarea>
              <small class="text-muted">บันทึกข้อมูลสำคัญหรือหมายเหตุส่วนตัว</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button type="button" class="btn btn-light btn-cancel">
          <i class="bi bi-x-circle"></i> ยกเลิก
        </button>
        <button type="button" class="btn btn-dark btn-save" @click="saveUser">
          <i class="bi bi-check-circle"></i> บันทึกการเปลี่ยนแปลง
        </button>
      </div>
    </div>

    <!-- Change Password Modal -->
    <div 
      class="modal fade" 
      id="changePasswordModal" 
      tabindex="-1" 
      aria-labelledby="changePasswordModalLabel" 
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modern-modal">
          <div class="modal-header">
            <div>
              <h5 class="modal-title" id="changePasswordModalLabel">
                <i class="bi bi-shield-lock"></i> เปลี่ยนรหัสผ่าน
              </h5>
              <p class="text-muted small mb-0">กรุณากรอกรหัสผ่านเดิมและรหัสผ่านใหม่</p>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="form-label">
                <i class="bi bi-lock"></i> รหัสผ่านเดิม
              </label>
              <input 
                type="password" 
                class="form-control modern-input" 
                placeholder="กรอกรหัสผ่านเดิม" 
                v-model="passwordData.oldPassword"
              >
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="bi bi-key"></i> รหัสผ่านใหม่
              </label>
              <input 
                type="password" 
                class="form-control modern-input" 
                placeholder="กรอกรหัสผ่านใหม่" 
                v-model="passwordData.newPassword"
              >
              <small class="text-muted">รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร</small>
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="bi bi-check2-circle"></i> ยืนยันรหัสผ่านใหม่
              </label>
              <input 
                type="password" 
                class="form-control modern-input" 
                placeholder="กรอกรหัสผ่านใหม่อีกครั้ง" 
                v-model="passwordData.confirmPassword"
              >
            </div>

            <div v-if="passwordError" class="alert alert-danger d-flex align-items-center">
              <i class="bi bi-exclamation-triangle me-2"></i>
              {{ passwordError }}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">
              <i class="bi bi-x"></i> ยกเลิก
            </button>
            <button type="button" class="btn btn-dark" @click="changePassword">
              <i class="bi bi-check2"></i> บันทึกรหัสผ่าน
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap';

export default {
  data() {
    return {
      my_user: {
        username: "",
        email: "",
        firstName: "",
        lastName: "",
        note: ""
      },
      passwordData: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      passwordError: ""
    };
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      try {
        var accessToken = localStorage.getItem("accessToken");
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        this.my_user = data.data;
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    },

    async saveUser() {
      try {
        var accessToken = localStorage.getItem("accessToken");
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          },
          body: JSON.stringify(this.my_user)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        alert('บันทึกข้อมูลสำเร็จ!');
      } catch (error) {
        console.error('Error saving user data:', error);
        alert('ไม่สามารถบันทึกข้อมูลได้');
      }
    },

    async changePassword() {
      this.passwordError = "";

      if (this.passwordData.newPassword !== this.passwordData.confirmPassword) {
        this.passwordError = "รหัสผ่านใหม่ไม่ตรงกัน!";
        return;
      }

      if (this.passwordData.newPassword.length < 6) {
        this.passwordError = "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร!";
        return;
      }

      try {
        var accessToken = localStorage.getItem("accessToken");
        const response = await fetch(`${process.env.VUE_APP_API_URL}/api/users/changepassword`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          },
          body: JSON.stringify({
            oldPassword: this.passwordData.oldPassword,
            password: this.passwordData.newPassword,
            confirmPassword: this.passwordData.confirmPassword
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const modalElement = document.getElementById('changePasswordModal');
        const modal = bootstrap.Modal.getInstance(modalElement);
        modal.hide();

        this.passwordData = {
          oldPassword: "",
          newPassword: "",
          confirmPassword: ""
        };

        alert('เปลี่ยนรหัสผ่านสำเร็จ!');
      } catch (error) {
        console.error('Error changing password:', error);
        this.passwordError = 'ไม่สามารถเปลี่ยนรหัสผ่านได้ กรุณาตรวจสอบรหัสผ่านเดิม';
      }
    }
  }
}
</script>

<style scoped>
.profile-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem;
  /* background: #f5f5f5; */
  min-height: 100vh;
}

.profile-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e5e5;
}

.profile-icon {
  width: 70px;
  height: 70px;
  background: #2d3748;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.5rem;
}

.profile-icon i {
  font-size: 2.5rem;
  color: white;
}

.profile-header h4 {
  font-weight: 700;
  color: #1a202c;
  margin: 0;
}

.profile-content {
  /* background: white;
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e5e5; */
}

.info-card {
  background: #F5F6FA;
  border-radius: 12px;
  padding: 2rem;
  height: 100%;
  border: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
}

.card-title {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e5e5e5;
}

.card-title i {
  font-size: 1.3rem;
  margin-right: 0.5rem;
  color: #4a5568;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.form-label i {
  margin-right: 0.5rem;
  color: #718096;
}

.modern-input,
.modern-textarea {
  border: 2px solid #e5e5e5;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  background: white;
}

.modern-input:focus,
.modern-textarea:focus {
  border-color: #4a5568;
  box-shadow: 0 0 0 3px rgba(74, 85, 104, 0.1);
  outline: none;
  background: white;
}

.modern-textarea {
  resize: vertical;
  min-height: 120px;
}

.password-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 1.5rem;
  border: 2px solid #e5e5e5;
}

.btn-change-password {
  border-radius: 8px;
  padding: 0.5rem 1.25rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border-width: 2px;
}

.btn-change-password:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: #2d3748;
  color: white;
  border-color: #2d3748;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
  /* padding-top: 2rem; */
  /* border-top: 2px solid #e5e5e5; */
}

.btn-save,
.btn-cancel {
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-width: 2px;
}

.btn-save {
  background: #2d3748;
  border-color: #2d3748;
  color: white;
}

.btn-save:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  background: #1a202c;
  border-color: #1a202c;
}

.btn-cancel {
  background: white;
  border: 2px solid #e5e5e5;
  color: #4a5568;
}

.btn-cancel:hover {
  background: #F5F6FA;
  border-color: #cbd5e0;
}

/* Modal Styles */
.modern-modal {
  border-radius: 16px;
  border: 1px solid #e5e5e5;
  overflow: hidden;
}

.modern-modal .modal-header {
  background: #FFFFFFFF;
  color: black;
  border: none;
  padding: 1.5rem 2rem;
}

.modern-modal .modal-title {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  /* color: white; */
}

.modern-modal .modal-header p {
  color: #e2e8f0;
}

.modern-modal .modal-header .btn-close {
  filter: brightness(0) invert(1);
}

.modern-modal .modal-body {
  padding: 2rem;
  background: white;
}

.modern-modal .modal-footer {
  border-top: 2px solid #e5e5e5;
  padding: 1.25rem 2rem;
  background: #F5F6FA;
}

.alert {
  border-radius: 8px;
  border: none;
  font-weight: 500;
}

@media (max-width: 768px) {
  .profile-container {
    padding: 1rem;
  }

  .profile-header,
  .profile-content {
    padding: 1.5rem;
  }

  .profile-icon {
    width: 50px;
    height: 50px;
    margin-right: 1rem;
  }

  .profile-icon i {
    font-size: 1.8rem;
  }

  .action-buttons {
    flex-direction: column-reverse;
  }

  .btn-save,
  .btn-cancel {
    width: 100%;
    justify-content: center;
  }
}
</style>